<span [class.overMaxLength]="fieldContent?.length && fieldContent.length > maxLength">
    {{fieldContent ? fieldContent.length : 0}} / {{maxLength}}
</span>